import React, { useContext } from 'react';
import { MetadataContext } from '@/components';
import { ImageModel, LinkModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import HeroModulePublic from './HeroModulePublic';
import HeroModuleApp from './HeroModuleApp';

export type HeroModuleModel = ModuleBaseModel<
  {
    theme: 'Light' | 'Dark' | '';
    title: string;
    image: {
      desktopImage: ImageModel;
      mobileImage: ImageModel;
    };
    description: string;
    isH1: boolean;
    cta?: LinkModel;
    breadcrumb?: LinkModel[];
  } & ModuleBasePropsModel
>;

const HeroModule = (data: HeroModuleModel) => {
  const { isPublic } = useContext(MetadataContext);

  return isPublic ? <HeroModulePublic {...data} /> : <HeroModuleApp {...data} />;
};

export default HeroModule;
